import { useCallback, useEffect, useState } from "react";

export const ROTATE_MS = 12000;

export function useRotation(count, initial = 0) {
  const [index, setIndex] = useState(initial);
  const [paused, setPaused] = useState(false);
  const [cycle, setCycle] = useState(0);

  const go = useCallback((i) => {
    if (!count) return;
    setIndex(((i % count) + count) % count);
    setCycle((c) => c + 1);
  }, [count]);

  useEffect(() => {
    if (paused || count < 2 || document.hidden) return undefined;
    const t = setTimeout(() => go(index + 1), ROTATE_MS);
    return () => clearTimeout(t);
  }, [index, paused, count, go, cycle]);

  useEffect(() => {
    const onVis = () => setCycle((c) => c + 1);
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []);

  useEffect(() => { setIndex(initial); }, [initial]);

  return { index, paused, setPaused, go, cycle };
}

export const prefersReducedMotion = () =>
  typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
